"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = ChevronRight;
var _ChevronRight = require("@adobe/react-spectrum-workflow/dist/ChevronRight.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function ChevronRight(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_ChevronRight.A4uChevronRight, null));
}